module.exports = __webpack_public_path__ + "img/error.274bb831.jpg";